import { WizardComponent } from 'modules/trainings/components/Shared/WizardComponent'

interface TrainingRequestWizardProps {
  onClose: () => void
}

export const TrainingRequestWizard = ({ onClose }: TrainingRequestWizardProps) => {
  return (
    <WizardComponent
      actions={{
        onClose,
        onSubmit: async () => {
          onClose()
        },
      }}
    />
  )
}
